// Business name and business email are disabled,
// since those can not be modified in the Balance Onboarding API after creation.

export function shouldDisableBusinessIdentityFields(
  balanceExternalId: string | null
): boolean {
  return Boolean(balanceExternalId);
}
